/** /quality was the QC Dashboard's first address (2026-10-16); it lives at /qc-dashboard now. */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/quality/")({
  beforeLoad: () => {
    throw redirect({ to: "/qc-dashboard", replace: true });
  },
});
